import { Button } from '../../components';
import React from 'react';
import { ContentManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchFaqsList: any;
  status: any;
}
const FAQsBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchFaqsList,
    status,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    ContentManagementService.blockFAQs({ faqId: id, status }).then(() => {
      setBlocked(true);
    });
  };

  return (
    <>
      {!blocked ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            {status === 'blocked' ? 'Block' : 'Unblock'}
            {' '}
            FAQ
          </h2>
          <p>
            Are you sure you want to
            {' '}
            {status === 'blocked' ? 'block' : 'unblock'}
            {' '}
            this FAQ?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            FAQ
            {' '}
            {status === 'blocked' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchFaqsList();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default FAQsBlocked;
